export default "__VITE_ASSET__9ce13dca__"